function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#3056D3",
    fillOpacity: 0.06,
    style: {
      fill: "#3056D3",
      fill: "color(display-p3 0.1882 0.3373 0.8275)",
      fillOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0008 25.675C20.7945 25.675 20.6227 25.6062 20.4508 25.4687L12.5445 17.7C12.2352 17.3906 12.2352 16.9094 12.5445 16.6C12.8539 16.2906 13.3352 16.2906 13.6445 16.6L21.0008 23.7844L28.357 16.5312C28.6664 16.2219 29.1477 16.2219 29.457 16.5312C29.7664 16.8406 29.7664 17.3219 29.457 17.6312L21.5508 25.4C21.3789 25.5719 21.207 25.675 21.0008 25.675Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.10e5730677b93b83af30da92a8fa3a63.svg";
export { ForwardRef as ReactComponent };